/**
 *
 * ForegroundBlob
 *
 */

import { useCallback } from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";
import { Close as CloseIcon } from "@material-ui/icons";
import { IconButton } from "@material-ui/core";
import { withRouter } from "react-router-dom";

function ForegroundBlob({
  children,
  noLargePadding,
  noPadding,
  fullscreen,
  left,
  widthOverride,
  noZIndex,
  withClose = false,
  fromNewAppointment,
  location,
  history,
}) {
  const onClose = useCallback(
    () => {
      const { state = {} } = location;
      const from = state.from || "/dashboard";

      history.push(from);
    },
    [location, history],
  );

  return (
    <Wrapper
      left={left}
      fromNewAppointment={fromNewAppointment}
      withClose={withClose}
    >
      {withClose && (
        <RelativeContainer>
          <CloseWrapper>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </CloseWrapper>
        </RelativeContainer>
      )}
      {left ? (
        <LeftContent
          widthOverride={widthOverride}
          noPadding={noPadding}
          noLargePadding={noLargePadding}
        >
          {children}
        </LeftContent>
      ) : (
        <Content
          noZIndex={noZIndex}
          widthOverride={widthOverride}
          fullscreen={fullscreen}
          noPadding={noPadding}
          noLargePadding={noLargePadding}
        >
          {children}
        </Content>
      )}
    </Wrapper>
  );
}

ForegroundBlob.propTypes = {
  children: PropTypes.any,
  noLargePadding: PropTypes.bool,
  noPadding: PropTypes.bool,
  fullscreen: PropTypes.bool,
  left: PropTypes.bool,
  widthOverride: PropTypes.any,
  noZIndex: PropTypes.bool,
  withClose: PropTypes.bool,
  history: PropTypes.object,
  location: PropTypes.object,
  fromNewAppointment: PropTypes.object,
};

export default withRouter(ForegroundBlob);

const RelativeContainer = styled.div`
  width: 100%;
  position: absolute;
  height: 100%;
`;

const CloseWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  margin-right: 25px;
  margin-top: 25px;
  z-index: 20;
`;

const Wrapper = styled.div`
  margin-top: ${({ theme, fromNewAppointment }) =>
    !fromNewAppointment ? theme.blobMargin : 0}rem;
  width: 100%;
  display: flex;
  flex-flow: ${({ left }) => (left ? "row" : "row-reverse")};
  min-height: 20rem;
  // this is for the UserEditPage fix, and for agenda on dashboard!
  position: ${({ withClose }) => withClose && "relative"};
`;

function minHeight({ fullscreen }) {
  if (fullscreen) {
    return "50vh";
  }
  return "20rem";
}

const LeftContent = styled.div`
  width: 43rem;
  background-color: #fffcfa;
  ${({ noPadding, theme }) => !noPadding && `padding: ${theme.blobPadding}`};
  // Border radius
  border-radius: ${({ theme: { foregroundRounding } }) =>
    `0 ${foregroundRounding} ${foregroundRounding} 0`};
  ${({ theme, noLargePadding }) => theme.desktopUp`
      ${!noLargePadding && "padding-left: 250px"};`};
  ${({ widthOverride }) =>
    widthOverride && `width: ${widthOverride} !important`};
  ${({ theme }) => theme.phone`
    margin-right: 1rem;
  `};
`;

const Content = styled.div`
  min-height: ${minHeight};
  z-index: 10;
  ${({ noZIndex }) => noZIndex && "z-index: 0"};
  width: 100%;
  // Padding
  ${({ noPadding, theme }) => !noPadding && `padding: ${theme.blobPadding}`};
  ${({ theme, noLargePadding }) => theme.desktopLargeUp`
    ${!noLargePadding && "padding-right: 250px"};
  `};
  // Width
  ${({ theme }) => theme.tabletLandscapeUp`
    width: 80vw;
  `};
  // Border radius
  border-radius: ${({ theme: { foregroundRounding } }) =>
    ` ${foregroundRounding} 0 0 ${foregroundRounding}`};

  background-color: #F6EFE8;
  ${({ widthOverride }) =>
    widthOverride && `width: ${widthOverride}!important`};
`;

export const BlobContent = styled.div`
  max-width: 1500px; // This max width forces the child components closer together.
  display: flex;
  justify-content: space-between;
  width: 100%;
  min-height: 276px;
  flex-direction: column;
  ${({ theme }) => theme.desktopUp`
    flex-direction: row;
  `};
`;
